<template>
    <div>
        <Head title="Дякуємо" />
        <Header pageName="Дякуємо" :cart-count="cartCount" />
        <div class="container mx-auto p-8">
            <div class="bg-white shadow-md rounded-lg p-6 text-center">
                <h2 class="text-2xl font-bold mb-4" v-if="paymentSuccess">Дякуємо!</h2>
                <h2 class="text-2xl font-bold mb-4" v-else>Payment Failed</h2>
                <p class="text-gray-700" v-if="paymentSuccess">
                    Оплата пройшла успішно
                </p>
                <p class="text-gray-700" v-else>
                    Оплата не пройшла, спройте пізніше
                </p>
                <Link class="mt-4 inline-block bg-blue-500 text-black py-2 px-4 rounded hover:bg-blue-600" href="/">
                    На головну
                </Link>
            </div>
        </div>
    </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import Header from "@/Component/Header.vue";

export default {
    components: {
        Header,
        Link,
    },
    props: {
        paymentSuccess: {
            type: Boolean,
            required: true,
        },
        cartCount: {
            type: Number,
            default: 0
        }
    },
};
</script>
